const environment = process.env.REACT_APP_API_ENV || 'production';

export const API_ENDPOINTS = {
  onboarding: {
    dev: 'http://localhost:3030/',
    pr: 'https://onboarding.staging.felloh.com/',
    sandbox: 'https://onboarding.sandbox.felloh.com/',
    staging: 'https://staging.felloh.com/onboarding/',
    production: 'https://api.felloh.com/onboarding/',
  },
};

export const API_ROUTES = {
  onboarding: {
    'application:create': () =>
      `${API_ENDPOINTS.onboarding[environment]}application`,
    'application:director:create': (applicationID) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${applicationID}/director`,
    'application:director:fetch': (applicationID, directorID) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${applicationID}/director/${directorID}`,
    'application:director:verification-session': (applicationID, directorID) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${applicationID}/director/${directorID}/verification-session`,
    'application:fetch-posc': (id) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${id}/posc`,
    'application:file-upload': (applicationID) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${applicationID}/file-upload`,
    'application:update': (applicationID) =>
      `${API_ENDPOINTS.onboarding[environment]}application/${applicationID}/update`,
    'company:lookup': () =>
      `${API_ENDPOINTS.onboarding[environment]}company/lookup`,
  },
  user: {
    'vat:lookup': () =>
      'https://user.api.felloh.com/vat-lookup'
  }
};

export default API_ROUTES;
